import { type UpdateOrCreateBankInfoData } from "@/services/user/bankInfo/bankInfoTypes";
import { BankAccountNumberNotValid, validateDomesticBankAccountNumber, validateIban } from "@/services/user/bankInfo/bankInfoValidators";

// API requires all fields - we just send empty string to satisfy the API.
export const factoryUpdateOrCreateUserBankInfoData = (data: Partial<UpdateOrCreateBankInfoData>): UpdateOrCreateBankInfoData => ({
  bankName: "",
  accountHolder: "",
  iban: "",
  ico: "",
  vat: "",
  accountNumber: "",
  ...data,
});

/**
 * Strips extra chars and makes IBAN uppercase
 * @throws {BankAccountNumberNotValid}
 **/
export const normalizeIban = (iban: string): string => {
  validateIban(iban);
  return iban.replace(/[\p{P}\s]+/gu, "").toUpperCase();
};

/**
 * Inserts spaces every 4 chars
 * @throws {BankAccountNumberNotValid}
 */
export const formatIban = (iban: string): string => {
  validateIban(iban);
  return normalizeIban(iban).replace(/(.{4})(?=.)/g, "$1 ");
};

export const isIban = (value: string): boolean => {
  try {
    validateIban(value);
    return true;
  } catch (e: unknown) {
    if (e instanceof BankAccountNumberNotValid) {
      return false;
    } else {
      throw e;
    }
  }
};

export const isDomesticBankAccount = (value: string): boolean => {
  try {
    validateDomesticBankAccountNumber(value);
    return true;
  } catch (e: unknown) {
    if (e instanceof BankAccountNumberNotValid) {
      return false;
    } else {
      throw e;
    }
  }
};
